import { Injectable } from '@angular/core';
import { UrlTree, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CoreData } from './core-data/core-data';
import { ENavigationRoute } from '../models/enums/navigation-route';
import { ENavigationErrorType } from '../models/enums/navigation-error-type';

@Injectable()
export class LoginGuard  {
    constructor(private router: Router,
        private coreData: CoreData) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {

        return true;
        
        if (!this.coreData.IsLoggedIn) {
            return this.router.createUrlTree([ENavigationRoute.Error, { type: ENavigationErrorType.UnAuthenticated }]);
        }

        const url = route.url[0] === undefined ? ENavigationRoute.WeeklyList : route.url[0].path;
        return (this.coreData.IsLoggedIn && this.hasPermission(url))
            || this.router.createUrlTree([ENavigationRoute.Error, { type: ENavigationErrorType.UnAuthorized }]);
    }

    hasPermission(url: string) {
        switch (url) {
            case ENavigationRoute.WeeklyList:
                if (this.coreData.Token) {
                    return true;
                }
                break;

        }
        return false;
    }
}

